import React from 'react';

class Link extends React.Component {
  render() {
    const {
      if: shouldLink,
      forceClick,
      onClick,
      linkProps,
      spanProps,
      children,
      ...props
    } = this.props;
    return shouldLink && this.props.href ? (
      <a ref="content" {...props} {...linkProps}>
        {children}
      </a>
    ) : (
      <span
        ref="content"
        {...spanProps}
        {...props}
        onClick={forceClick ? onClick : undefined}
        onKeyDown={e =>
          e.key === 'Enter' && (forceClick() ? onClick() : undefined)
        }
      >
        {children}
      </span>
    );
  }
}

Link.defaultProps = {
  forceClick: false,
};

export default Link;
